import { PageBlueprint } from '@backstage/frontend-plugin-api';
import homePlugin from '@backstage/plugin-home/alpha';

const welcomePage = PageBlueprint.make({
  name: 'welcome',
  params: {
    path: '/welcome',
    noHeader: true,
    loader: async () => {
      const { welcomePage: welcomePageElement } = await import(
        '../components/welcome/WelcomePage'
      );
      return welcomePageElement;
    },
  },
});

const helpPage = PageBlueprint.make({
  name: 'help',
  params: {
    path: '/help',
    noHeader: true,
    loader: async () => {
      const { helpPage: helpPageElement } = await import(
        '../components/help/HelpPage'
      );
      return helpPageElement;
    },
  },
});

const gettingStartedPage = PageBlueprint.make({
  name: 'getting-started',
  params: {
    path: '/getting-started',
    noHeader: true,
    loader: async () => {
      const { gettingStartedPage: gettingStartedPageElement } = await import(
        '../components/getting-started/GettingStartedPage'
      );
      return gettingStartedPageElement;
    },
  },
});

/** Custom /welcome, /help, /getting-started; default /home page (and its derived nav item) disabled. */
const homeFeature = homePlugin.withOverrides({
  extensions: [
    welcomePage,
    helpPage,
    gettingStartedPage,
    // StableVisitListener in appRootModule needs visitsApiRef (removed from apis.ts in Phase 1).
    homePlugin.getExtension('api:home/visits').override({ disabled: false }),
    homePlugin.getExtension('page:home').override({ disabled: true }),
  ],
});

export default homeFeature;
